export default __webpack_public_path__ + "static/media/1831.51128bad.png";